const getElements = (selector) => {
    return Array.from(document.querySelectorAll(selector))
}

const getElement = (selector) => {
    return document.querySelector(selector)
}

export {getElements, getElement}
